// extracted by mini-css-extract-plugin
export default {"notice":"main_notice__NYj9Y","noticeItem":"main_noticeItem__M+ofg","chat":"main_chat__GX+ln"};